'use strict';

var elementCtrl = [function() {
    var _this = this;
    this.config = false;
    this.elementToggle = true;

    this.toggleConfig = function() {
        this.config = !this.config;
    };
    this.toggleSection = function() {
        this.elementToggle = !this.elementToggle;
    }

    this.removeSubElement = function(id) {
        this.removeElement({
            id: id
        });
    };

    this.cloneSubElement = function(id) {
        this.cloneElement({
            id: id
        });
    };

    this.getBorderBottomStyle = function() {
        let styles = {};
        if (_this.isAdmin) styles['padding-bottom'] = '0px';
        if ((_this.element.type == 'group' || _this.element.type == 'simplelist') && !_this.elementToggle) {
            styles['border-bottom'] = '2px solid #dddddd';
        }
        return styles;
    };
    // console.log('elementDir reportConfig', this.reportConfig);
}];

module.exports = function() {
    return {
        restrict: 'E',
        scope: {
            element: '=',
            removeElement: '&',
            cloneElement: '&',
            form: '=',
            reportConfig: '=',
            subnodos: '=',
            isForValidator: '=',
            pageIndex: '=',
            elementIndex: '=',
            isAdmin: '=',
        },
        replace: true,
        controller: elementCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'dashboard-builder/elementDirective.html'
    };
};
